<template>
  <div v-if="$store.getters.driver_type === 'Manager'">
    <v-btn color="primary" outlined class="mb-3" @click="openHistory">Previous Visits</v-btn>
    <v-dialog v-model="open" max-width="750">
      <v-card>
        <v-card-title>Previous Visits</v-card-title>
        <v-card-text>
          <p>Latest 10 visits marked Completed, Closed or Extras / Notes, through today.</p>
          <v-progress-linear v-if="loading" indeterminate />
          <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
          <v-alert v-if="success" type="success" dense>{{ success }}</v-alert>
          <v-simple-table v-if="!loading">
            <thead><tr><th>Date</th><th>Driver</th><th>Status</th><th></th></tr></thead>
            <tbody>
              <tr v-for="visit in visits" :key="visit.id">
                <td>{{ visit.date }}</td><td>{{ visit.driver }}</td><td>{{ visit.status }}</td>
                <td><v-btn small text color="primary" :disabled="saving" @click="chooseVisit(visit)">Duplicate</v-btn></td>
              </tr>
              <tr v-if="!visits.length"><td colspan="4">No qualifying visits found.</td></tr>
            </tbody>
          </v-simple-table>
          <v-form v-if="selectedVisit" @submit.prevent="duplicate">
            <h3 class="mt-4">Duplicate visit from {{ selectedVisit.date }}</h3>
            <v-text-field v-model="newDate" label="New service date" type="date" required :disabled="saving" />
            <v-select v-model="newDriver" :items="drivers" item-value="id" item-text="label" label="Assigned driver" required :disabled="saving" />
            <v-checkbox v-model="includeExtras" label="Include extras" :disabled="saving" />
            <v-btn type="submit" color="primary" :loading="saving" :disabled="!newDate || !newDriver || saving">Duplicate Visit</v-btn>
            <v-btn text :disabled="saving" @click="selectedVisit = null">Cancel</v-btn>
          </v-form>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text :disabled="saving" @click="open = false">Close</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CustomerVisits",
  props: {
    customerId: { type: [Number, String], required: true },
  },
  data: () => ({
    open: false,
    loading: false,
    saving: false,
    visits: [],
    drivers: [],
    selectedVisit: null,
    newDate: "",
    newDriver: null,
    includeExtras: false,
    error: "",
    success: "",
  }),
  methods: {
    credentials() {
      return { driver_id: this.$store.getters.driver_id, token: this.$store.getters.token, customer_id: this.customerId };
    },
    showError(error) {
      const data = error.response && error.response.data;
      this.error = (data && (data.msg || data.message)) || error.message || "Unable to load visits. Please try again.";
      if (data && data.error === "logout") this.$router.push("/logout");
    },
    async openHistory() {
      this.open = true;
      this.loading = true;
      this.error = "";
      this.success = "";
      this.visits = [];
      this.selectedVisit = null;
      try {
        const [history, drivers] = await Promise.all([
          this.$http.post(this.$api + "customerVisits", this.credentials()),
          this.$http.post(this.$api + "allDrivers", { manual_route: true }),
        ]);
        if (history.data.status !== "ok") throw new Error(history.data.msg);
        if (drivers.data.status !== "ok") throw new Error(drivers.data.msg);
        this.visits = history.data.data;
        this.drivers = drivers.data.data.map(driver => ({ id: Number(driver.id), label: `${driver.name} (${driver.letter})` }));
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    chooseVisit(visit) {
      this.selectedVisit = visit;
      this.newDate = "";
      this.newDriver = null;
      this.includeExtras = false;
      this.error = "";
      this.success = "";
    },
    async duplicate() {
      if (this.saving || !this.selectedVisit || !this.newDate || !this.newDriver) return;
      this.saving = true;
      this.error = "";
      this.success = "";
      try {
        const response = await this.$http.post(this.$api + "duplicateCustomerVisit", {
          ...this.credentials(), visit_id: this.selectedVisit.id, newDate: this.newDate,
          newDriver: this.newDriver, include_extras: this.includeExtras,
        });
        if (response.data.status !== "ok") throw new Error(response.data.msg);
        this.success = response.data.msg;
        this.selectedVisit = null;
      } catch (error) {
        this.showError(error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
